/* eslint-disable @typescript-eslint/no-explicit-any */
import {useDispatch, useSelector} from "react-redux";
import {CreateInviteRequest, InviteRequestInit,} from "@/model/request/invite/CreateInviteRequest.ts";
import {BaseInput} from "../input/BaseInput";
import {BaseSelect} from "../input/BaseSelect";
import {useFormik} from "formik";
import {invite, InviteState} from "@/store/modules/invite.ts";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";

export default function InviteForm() {
    const dispatch = useDispatch<any>();
    const inviteState = useSelector<any>((state) => state.invite) as InviteState;

    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
        );
    };

    const handleSubmit = async (value: CreateInviteRequest) => {
        await dispatch(
            invite.action.createInvite({
                data: value,
                onSuccess: (response: any) => showSuccessMessage(response),
                onError: (response: any) => showErrorMessage(response),
            })
        );
        formik.resetForm();
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: InviteRequestInit,
        // validationSchema: AuthValidation.invite,
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="div-block-7">
                <BaseInput
                    formik={formik}
                    className="form_input invite w-input"
                    maxLength={256}
                    name="inviteEmail"
                    data-name="Name"
                    placeholder="Enter email address"
                    type="text"
                    id="name"
                />
                <BaseSelect
                    items={[
                        {value: "", label: "Select Role"},
                        {value: "Admin", label: "Admin"},
                        {value: "Member", label: "Member"},
                    ]}
                    formik={formik}
                    errorStyle={{color: "red"}}
                    autoComplete={"off"}
                    id="field"
                    name="inviteRoleId"
                    className="form_input invite-select w-select"
                ></BaseSelect>
            </div>
            <div className="div-block-8">
                <a href="#" className="link-block-3 w-inline-block">
                    <div className="text-block-3">+ Add another email</div>
                </a>
            </div>
            <BaseInput
                formik={formik}
                name={"input"}
                loading={inviteState.loading}
                type="submit"
                className="button is-large is-wide w-button"
                value="Submit"
            />
        </form>
    );
}
